import "./index.css";

import "./containers/heroImage/heroImage.css";
import "./containers/breadcrumb/breadcrumb.css";
import "./containers/blogList/blogList.css";
import "./containers/farmerList/farmerList.css";
import "./containers/farmerProfile/farmerProfile.css";
import "./containers/title/title.css";
import "./containers/publishedDate/publishedDate.css";
import "./containers/404/404.css";
import "./containers/footer/footer.css";
import "./containers/button/button.css";

import setupBackToTop from "./containers/backToTop/backToTop";
import setupHeader from "./containers/header/header";
import setupPagination from "./containers/pagination/pagination";
import setupRecentBlog from "./containers/recentBlog/recentBlog";
import setupFarmerProfile from "./containers/farmerProfile/farmerProfile";
import setupCardList from "./containers/blogList/blogList";

import { createErrorNotifier, IErrorNotifier } from "./errorNotifier";

export const errorNotifier = createErrorNotifier("aigle-blog");

export interface IContext {
  errorNotifier: IErrorNotifier;
}

function setupContainers(context: IContext) {
  setupBackToTop();
  setupHeader();
  setupPagination(context);
  setupRecentBlog();
  setupFarmerProfile();
  setupCardList();
}

function main() {
  try {
    const context = { errorNotifier };
    setupContainers(context);
  } catch (error) {
    errorNotifier.notify(error as Error);
  }
}

main();
